export default function ComplianceBaseline() {
  return (
    <div style={{ padding: "1.5rem", maxWidth: "900px" }}>
      <h1>Compliance Baseline (Draft)</h1>

      <h2>Plain language summary</h2>
      <p>
        This is a checklist of basic steps to keep the pilot safe and compliant. It focuses on
        access control, data minimization, and clear communication with staff.
      </p>

      <h2>1. Governance</h2>
      <ul>
        <li>Identify the data controller (school) and data processor (app owner)</li>
        <li>Nominate a data protection lead for approvals and reviews</li>
        <li>Record decisions in a simple log</li>
      </ul>

      <h2>2. Access control</h2>
      <ul>
        <li>Require authenticated access for all pages</li>
        <li>Limit data to the teacher's own classes</li>
        <li>Restrict admin views to admins only</li>
        <li>Review roles every term</li>
      </ul>

      <h2>3. Data minimization</h2>
      <ul>
        <li>Store only what is necessary for the pilot</li>
        <li>Avoid sensitive data unless required</li>
        <li>Do not store student medical or safeguarding data</li>
      </ul>

      <h2>4. Transparency</h2>
      <ul>
        <li>Publish the privacy notice to staff</li>
        <li>Provide a clear contact for data requests</li>
        <li>Maintain a SAR log to track status and deadlines</li>
        <li>Notify staff of any policy changes</li>
      </ul>

      <h2>5. Security</h2>
      <ul>
        <li>Use Firebase security rules for least privilege</li>
        <li>Enable MFA for admin accounts if available</li>
        <li>Keep dependencies updated</li>
      </ul>

      <h2>6. Retention</h2>
      <ul>
        <li>Define retention periods for each data type</li>
        <li>Schedule cleanup at the end of pilot</li>
        <li>Confirm deletion process works</li>
      </ul>

      <h2>7. Incident response</h2>
      <ul>
        <li>Define who to notify in case of data issues</li>
        <li>Log incidents and resolutions</li>
        <li>Notify stakeholders as required</li>
      </ul>

      <h2>8. Review cadence</h2>
      <ul>
        <li>Review the pilot at 30/60/90 days</li>
        <li>Adjust policies based on feedback</li>
      </ul>

      <p style={{ marginTop: "1.5rem", fontStyle: "italic" }}>
        Disclaimer: This draft is not legal advice and should be reviewed by the school's data
        protection lead.
      </p>
    </div>
  );
}
